import React, { useContext } from 'react';

import OrderDetailContext from '../../contexts/OrderDetailContext';
import canDeliverFilesHelper from '../../shared/Actions/DeliverFiles/CanDeliverFilesHelper';
import DeliverFiles from '../../shared/Actions/DeliverFiles/DeliverFiles';
import LineItem from '../../../../../types/cart/LineItem';
import DeliverFilesSpinnerThumbButton from '../../shared/Actions/DeliverFiles/Spinner/DeliverFilesSpinnerThumbButton';
import OrderLineItemArtwork from '../OrderLineItemArtwork';

interface DeliverFilesInListProps {
  lineItem: LineItem;
}

const DeliverFilesInList = ({ lineItem }: DeliverFilesInListProps) => {
  const canDeliverFiles = canDeliverFilesHelper(lineItem);
  const { order } = useContext(OrderDetailContext);

  if (!canDeliverFiles.enabled) {
    // No files are needed (cancelled, unprinted product, files already delivered).
    // Show the thumbnail
    return <OrderLineItemArtwork lineItem={lineItem} dispatchEventCategory="order_list_interaction" />;
  }

  if (!order) {
    // Not all required data has finished loading, but we are certain files will be needed.
    return (
      <DeliverFilesSpinnerThumbButton thumbSize="md" thumbClasses="lg:pd-rounded-r-0" />
    );
  }

  const fullLineItem = order.lineItems.find((sanitizedLineItem) => sanitizedLineItem.id === lineItem.id);

  if (!fullLineItem) {
    return null;
  }

  return (
    <DeliverFiles
      order={order}
      lineItem={fullLineItem}
      thumbSize="md"
      thumbClasses="lg:pd-rounded-r-0"
      dispatchEventCategory="order_list_interaction"
    />
  );
};

export default DeliverFilesInList;
